<script setup lang="ts">
import { JobBoard } from '@/core/collections/job-boards/job-board.interface';
import LanguageSelector from '@/core/components/form-elements/LanguageSelector.vue';

const jobBoard = defineModel<JobBoard>('modelValue', { required: true });
</script>

<template>
   <section>
      <div class="row">
         <div class="col-half">
            <LanguageSelector
               v-model:languageIds="jobBoard.language_ids"
               v-model:default-language-id="jobBoard.default_language_id"
               :languages="jobBoard.languages"
            />
         </div>
      </div>
   </section>
</template>
